import type { HttpParameters } from '@coris-ts/data/parameter-type'
import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { ApiEndpoint } from '../../../shared/api-endpoint'

export class GetSubscriptionsQuery extends GetNetworkQuery {
  constructor (
    private readonly customerId: string,
    private readonly transactionId: string
  ) {
    super(ApiEndpoint.CustomerSubscriptions)
  }

  public get urlParameters(): HttpParameters {
    return {
      customerId: this.customerId
    }
  }

  public get queryParameters(): HttpParameters {
    return {
      transaction_id: this.transactionId
    }
  }
}
